import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, HostBinding, inject, input, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'big-icon',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnInit {
    private readonly elementRef = inject(ElementRef<HTMLElement>);
    private readonly sanitizer = inject(DomSanitizer);

    public readonly size = input.required<string>();
    public readonly inline = input<boolean>(false);
    private readonly computedClass = computed(() => `${this.inline() ? 'inline-block' : 'block'} aspect-square ${this.size()}`);

    @HostBinding('class') public classList = '';

    @HostBinding('innerHTML')
    public svgIcon?: SafeHtml;

    @Input()
    public set icon(icon: { name: string; data: string }) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        this.elementRef.nativeElement.setAttribute('data-title', icon.name);

        // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(icon.data);
    }

    public constructor() {
        effect(() => {
            this.classList = this.computedClass();
        });
    }

    public ngOnInit(): void {
        this.classList = this.computedClass();
    }
}
